export default {
  'menu.system': 'システム管理',
  'menu.system.user': 'ユーザー管理',
  'menu.system.role': 'ロール管理',
  'menu.system.menu': 'メニュー管理',
  'menu.system.dept': '部門管理',
  'menu.monitor': 'モニター',
  'menu.monitor.login-log': 'ログイン履歴',
  'menu.monitor.oper-log': '操作履歴',
  'menu.login': 'ログイン',
};
